import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const state = {
    subscriber_type: '', //subscriber type OS/NS
    subscribe_response: '', //subscribe endpoint response in JSON
    transition_userid: '',
    transition_csmatno: '',
    transition_csorderno: '',
    transition_type: '',
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
